import { BrowserRouter as Router } from 'react-router-dom';

import Routes from './Routes';
import { AuthProvider } from './contexts/Auth';
import { ApplicationsProvider } from './contexts/Applications';
import { UserProvider } from './contexts/User';
import { PlansProvider } from './contexts/Plans';

const App = () => (
  <Router>
    <AuthProvider>
      <UserProvider>
        <PlansProvider>
          <ApplicationsProvider>
            <Routes />
          </ApplicationsProvider>
        </PlansProvider>
      </UserProvider>
    </AuthProvider>
  </Router>
);

export default App;
